<template>
    <div
        class="selectionHorizontal"
        v-bind:class="{
            _picked: isPicked,
            _disabled: isDisabled,
            _suspended: isSuspended,
            _onlyTag: isOnlyTag,
            _hasPoint: point !== null,
            _hasTag: tag !== null,
            _empty: isEmpty,
            _oddsChange: showPrice && oddsChange !== null,
        }"
        v-on:click="handleClick"
    >
        <Skeleton v-if="isLoading" />
        <SvgIcon
            v-else-if="isSuspended"
            name="icon-system-odds-lock"
            size="sm"
        />
        <template v-else>
            <div v-if="point !== null" class="oddsPoint">
                {{ point }}
            </div>
            <div v-if="tag !== null" class="oddsTag">
                {{ tag }}
            </div>
            <div v-if="showPrice" class="oddsArea">
                <div class="odds">
                    <div class="oddsValue">
                        {{ price }}
                    </div>
                </div>
                <div
                    class="oddsStates"
                    v-bind:class="oddsChange !== null ? `oddsStates-${oddsChange}` : ''"
                >
                    <div v-show="oddsChange" class="triangle" />
                </div>
            </div>
        </template>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue';
    import SvgIcon from '@/components/common/SvgIcon.vue';
    import Skeleton from '@/components/common/skeleton/Skeleton.vue';

    const props = withDefaults(defineProps<{
        point?: string | null;
        tag?: string | null;
        price?: string | null;
        oddsChange?: 'rise' | 'drop' | null;
        isPicked?: boolean;
        isDisabled?: boolean;
        isSuspended?: boolean;
        isLoading?: boolean;
    }>(), {
        point: null,
        tag: null,
        price: null,
        oddsChange: null,
        isPicked: false,
        isDisabled: false,
        isSuspended: false,
        isLoading: false,
    });

    const emit = defineEmits<{ click: [MouseEvent] }>();
    const isOnlyTag = computed(() => props.isPicked || props.isDisabled || props.price === null);
    const showPrice = computed(() => !props.isLoading && !props.isSuspended && !isOnlyTag.value);
    const isEmpty = computed(() => {
        const hasPoint = !!props.point;
        const hasTag = !!props.tag;
        const hasPrice = showPrice.value && !!props.price;
        return !props.isSuspended && !hasPoint && !hasTag && !hasPrice;
    });

    function handleClick(event: MouseEvent) {
        if (props.isLoading || props.isDisabled || props.isSuspended || isEmpty.value) return;

        emit('click', event);
    }
</script>

<style lang="scss" scoped>
    @import "@/components/odds/Odds";
    @import "@/components/odds/SelectionHorizontal";
</style>
